
const CarouselSnippet = () => (
  <pre>
    <code>
      <>
        <span className='cn'>&lt;div</span>
        <span className='cln'> class="</span>
        <span className='cn'>carve-lean-body</span>
        <span className='cln'>"</span>
        <span className='cn'>&gt;</span>
      </>
      <br />
      <>
        &nbsp;<span className='cn'>&lt;div</span>
        <span className='cln'> class="</span>
        <span className='cn'>carve-line</span>
        <span className='cln'>"</span>
        <span className='cn'>&gt;</span>
      </>
      <br />
      <>
        &nbsp;&nbsp;<span className='cn'>&lt;div</span>
        <span className='cln'> class="</span>
        <span className='cn'>box-12</span>
        <span className='cln'>"</span>
        <span className='cn'>&gt;</span>
      </>
      <br />
      <>
        &nbsp;&nbsp;&nbsp;<span className='cn'>&lt;div</span>
        <span className='cln'> class="</span>
        <span className='cn'>carve-carousel</span>
        <span className='cln'>"</span>
        <span className='cln'> data-carve-carousel</span>
        <span className='cn'>&gt;</span>
      </>
      <br />
      <>
        &nbsp;&nbsp;&nbsp;&nbsp;<span className='cn'>&lt;ul</span>
        <span className='cln'> class="</span>
        <span className='cn'>carve-slides</span>
        <span className='cln'>"</span>
        <span className='cln'> data-slides</span>
        <span className='cn'>&gt;&lt;/ul&gt;</span>
      </>
      <br />
      <>
        &nbsp;&nbsp;&nbsp;<span className='cn'>&lt;/div&gt;</span>
      </>
      <br />
      <>
        &nbsp;&nbsp;&nbsp;<span className='cn'>&lt;div</span>
        <span className='cln'> class="</span>
        <span className='cn'>carve-carousel-dots</span>
        <span className='cln'>"</span>
        <span className='cln'> data-carve-carousel-dots</span>
        <span className='cn'>&gt;&lt;/div&gt;</span>
      </>
      <br />
      <>
        &nbsp;&nbsp;&nbsp;<span className='cn'>&lt;div</span>
        <span className='cln'> class="</span>
        <span className='cn'>carve-arrows-outer</span>
        <span className='cln'>"</span>
        <span className='cn'>&gt;</span>
      </>
      <br />
      <>
        &nbsp;&nbsp;&nbsp;&nbsp;<span className='cn'>&lt;button</span>
        <span className='cln'> class="</span>
        <span className='cn'>carve-button-main</span>
        <span className='cln'>"</span>
        <span className='cln'> data-carve-carousel-button="</span>
        <span className='cn'>prev</span>
        <span className='cln'>"</span>
        <span className='cn'>&gt;</span>
        <span className=''>&#10094;</span>
        <span className='cn'>&lt;/button&gt;</span>
      </>
      <br />
      <>
        &nbsp;&nbsp;&nbsp;&nbsp;<span className='cn'>&lt;button</span>
        <span className='cln'> class="</span>
        <span className='cn'>carve-button-main</span>
        <span className='cln'>"</span>
        <span className='cln'> data-carve-carousel-button="</span>
        <span className='cn'>next</span>
        <span className='cln'>"</span>
        <span className='cn'>&gt;</span>
        <span className=''>&#10095;</span>
        <span className='cn'>&lt;/button&gt;</span>
      </>
      <br />
      <>
        &nbsp;&nbsp;&nbsp;<span className='cn'>&lt;/div&gt;</span>
      </>
      <br />
      <>
        &nbsp;&nbsp;<span className='cn'>&lt;/div&gt;</span>
      </>
      <br />
      <>
        &nbsp;<span className='cn'>&lt;/div&gt;</span>
      </>
      <br />
      <>
        <span className='cn'>&lt;/div&gt;</span>
      </>
    </code>

  </pre>
);
export { CarouselSnippet };